<template>
  <div class="text--main" v-html="text"></div>
</template>

<script>

export default {
  name: 'MainText',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>

